import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { GuestsPlatformConfirmationsStats } from 'types/guest.types';

const QuestionnaireStatsQuery = gql`
  query questionnaireStats($eventId: Int!) {
    questionnaireStats(eventId: $eventId) {
      questionnaireSubmitted
    }
  }
`;

export interface QuestionnaireStatsResponse {
  questionnaireStats: {
    questionnaireSubmitted: number;
  };
}

const RegistrationsByPlatformQuery = gql`
  query registrationsByPlatform($eventId: Int!) {
    guestsPlatformConfirmationsStats(eventId: $eventId) {
      calendar
      slack
      eventPage
    }
  }
`;

export interface RegistrationsByPlatformResponse {
  guestsPlatformConfirmationsStats: GuestsPlatformConfirmationsStats;
}

export const eventRegistrationDataApi = {
  questionnaireStats: async (
    eventId: number
  ): Promise<QuestionnaireStatsResponse['questionnaireStats']> => {
    return gqlClient
      .request<QuestionnaireStatsResponse>(QuestionnaireStatsQuery, { eventId })
      .then((res) => res.questionnaireStats);
  },

  registrationsByPlatform: async (
    eventId: number
  ): Promise<RegistrationsByPlatformResponse['guestsPlatformConfirmationsStats']> => {
    return gqlClient
      .request<RegistrationsByPlatformResponse>(RegistrationsByPlatformQuery, { eventId })
      .then((res) => res.guestsPlatformConfirmationsStats);
  }
};
